import { useEffect, useState } from 'react'
import { api } from '../api'

export function AdminUsersPage() {
  const [admins, setAdmins] = useState<Array<{ id: string; username: string; role: string }>>([])
  const [adminPw, setAdminPw] = useState<Record<string, string>>({})
  const [adminMsg, setAdminMsg] = useState<string | null>(null)

  const loadAdmins = () => {
    void api.listAdmins()
      .then((r) => setAdmins(r.admins))
      .catch(() => setAdmins([]))
  }

  useEffect(() => {
    loadAdmins()
  }, [])

  return (
    <div className="stack">
      <div className="card stack">
        <h2 style={{ margin: 0 }}>建立管理員 (Admin)</h2>
        <CreateUserForm onCreated={async () => loadAdmins()} />
      </div>

      <div className="card stack">
        <h2 style={{ margin: 0 }}>管理員列表與重設密碼</h2>
        <div className="stack">
          {admins.length === 0 ? <div className="muted">暫未有管理員</div> : null}
          {admins.map((a) => (
            <div key={a.id} className="row" style={{ justifyContent: 'space-between', borderBottom: '1px solid var(--border)', paddingBottom: '0.75rem' }}>
              <div>
                <strong style={{ fontSize: '1.05rem' }}>{a.username}</strong>
                <span className="pill" style={{ marginLeft: '0.5rem', fontSize: '0.75rem' }}>{a.role}</span>
              </div>
              <div className="row">
                <input
                  className="input input-sm"
                  type="password"
                  placeholder="新密碼 (>=8)"
                  value={adminPw[a.id] ?? ''}
                  style={{ width: '130px' }}
                  onChange={(e) => setAdminPw((prev) => ({ ...prev, [a.id]: e.target.value }))}
                />
                <button
                  className="btn btn-sm"
                  type="button"
                  onClick={async () => {
                    const next = adminPw[a.id] ?? ''
                    setAdminMsg(null)
                    if (next.length < 8) {
                      setAdminMsg(`「${a.username}」新密碼更少需 8 位`)
                      return
                    }
                    try {
                      await api.resetUserPassword(a.id, next)
                      setAdminPw((prev) => ({ ...prev, [a.id]: '' }))
                      setAdminMsg(`✅ 已重設「${a.username}」密碼`)
                    } catch (err) {
                      setAdminMsg(err instanceof Error ? err.message : '重設失敗')
                    }
                  }}
                >
                  重設密碼
                </button>
              </div>
            </div>
          ))}
        </div>
        {adminMsg ? <div className={`muted font-sm ${adminMsg.includes('✅') ? 'success' : 'error'}`} style={{ marginTop: '0.5rem' }}>{adminMsg}</div> : null}
      </div>
    </div>
  )
}

function CreateUserForm({ onCreated }: { onCreated?: () => Promise<void> }) {
  const [username, setUsername] = useState('')
  const [password, setPassword] = useState('')
  const [msg, setMsg] = useState<string | null>(null)
  return (
    <form
      className="stack"
      onSubmit={async (e) => {
        e.preventDefault()
        setMsg(null)
        try {
          await api.createUser({ username, password, role: 'admin' })
          setUsername('')
          setPassword('')
          setMsg('✅ 已建立新 Admin')
          if (onCreated) await onCreated()
        } catch (err) {
          setMsg(err instanceof Error ? err.message : '失敗')
        }
      }}
    >
      <div className="row">
        <input className="input" placeholder="帳號名稱" value={username} onChange={(e) => setUsername(e.target.value)} required />
        <input
          className="input"
          placeholder="初始密碼"
          type="password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          required
        />
        <button className="btn primary" type="submit">
          建立
        </button>
      </div>
      {msg ? <div className="muted font-sm" style={{ marginTop: '0.25rem' }}>{msg}</div> : null}
    </form>
  )
}
